import { render, staticRenderFns } from "./updateemail.vue?vue&type=template&id=532c3dd2&"
import script from "./updateemail.vue?vue&type=script&lang=js&"
export * from "./updateemail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2044461438/src/tacotrade-platform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('532c3dd2')) {
      api.createRecord('532c3dd2', component.options)
    } else {
      api.reload('532c3dd2', component.options)
    }
    module.hot.accept("./updateemail.vue?vue&type=template&id=532c3dd2&", function () {
      api.rerender('532c3dd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/updateemail.vue"
export default component.exports